<!-- Breadcrumb Section starts -->
<section class="container breadcrumb-desk">
  <div class="breadcrumb">
    <ul>
      <li><a href="javascript:void(0)" routerLink="/hotel"><i class="fas fa-home me-2"></i>Home</a></li>
      <li>
        <a href="javascript:void(0)" (click)="goBack()"><i class="fas fa-hotel me-2"></i>Hotels In {{hotelSearchRequest.CityName}}, {{hotelSearchRequest.CountryName}}</a>
      </li>
      <li><i class="fas fa-building me-2"></i>{{hotelDetails.Name}}</li>
      <li><i class="fas fa-calendar-alt me-2"></i>{{hotelSearchRequest.CheckIn | date: "dd MMM yy"}} - {{hotelSearchRequest.CheckOut | date: "dd MMM yy"}}, {{hotelDetails.Rooms.Room[0].NoOfRoom}} Room(s), {{hotelDetails.Rooms.Room[0].NoOfAdult}} Adult(s)</li>
    </ul>
    <div><a class="backbtn" href="javascript:void(0)" (click)="goBack()">Back To Result</a></div>
  </div>
</section>
<!-- End Of breadcrumb section -->
<!-- Hotel Detail Section Starts -->
<!--Loader Section Start-->
<section class="hotel-detail" *ngIf="waitingloader">
  <div class="container">
    <div class="loader-hotel" style="text-align: center;">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="col-md-12">
              <span class="skeleton-box" style="height:422px;"></span>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-md-12">
              <span class="skeleton-box" style="height:200px;"></span>
            </div>
            <div class="col-md-12 mt-4">
              <span class="skeleton-box" style="height:200px;"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Loader Section End-->
<!--Result not found Start-->
<section class="hotel-detail" *ngIf="!waitingloader && showResult && !hotelDetails">
  <div class="container">
    <div style="text-align: center;">
      <div class="res-no-data error-four-main">
        <div class="four-img">
          <img src="assets/images/filter-no-result.png" alt="No Result Found." />
        </div>
        <div class="four-page-not">
          <span>Oops !</span> No Rooms Available
        </div>
        <div class="nf-details">
          Please try a different hotel.
        </div>
        <div class="src-again" style="padding-bottom:20px;">
        </div>
      </div>
    </div>
  </div>
</section>
<!--Result not found end-->
<!-- Desktop view -->
<section class="container desk-hotel-detail" *ngIf="showResult && hotelDetails">
  <div class="row hotel-cust-card">
    <div class="col-12 d-flex justify-content-between align-items-center pb-3 flex-wrap">
      <div>
        <h4 class="mb-1 fw-bold hotel-name">
          {{hotelDetails.Name}}
          <span class="star-rt-ratings">
            <i *ngFor="let star of ' '.repeat(hotelDetails.Star).split('')" class="fas fa-star"></i>
          </span>
          <span class="badge border text-primary fw-normal">Hotel</span>
        </h4>
        <p class="text-muted mb-0 hotel-map-location">
          <i class="fas fa-map-location-dot"></i> {{hotelDetails.DisplayAdd}}
        </p>
      </div>
      <div class="text-end d-flex">
        <div class="end-rt-ratings">
          <div class="fw-semibold text1">Very Good</div>
          <small class="text-muted text2">6203 reviews</small>
        </div>
        <div class="text-white rt-ratings-number">4.6</div>
      </div>

    </div>
    <div class="col-8">



      <div class="image-section">
        <div class="main-image-wrapper">
          <div class="main-image-wrapper">
            <div class="main-image-wrapper">
              <div class="main-image-slider">
                <owl-carousel [options]="ImageMainShow"
                              [carouselClasses]="['row', 'owl-carousel']">
                  <div>
                    <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommontDovH6.jpg"
                         alt="Hotel Room">
                  </div>
                  <div>
                    <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonatGBex.jpg" alt="Image 2">
                  </div>
                  <div>
                    <img src="	https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonTfIIr0.jpg" alt="Image 3">
                  </div>
                </owl-carousel>

              </div>

              <div class="overlay-count">1 / 3</div>
            </div>
          </div>
        </div>
        <div class="mini-gallery-vertical">
          <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonatGBex.jpg"
               alt="Gallery 1" />
          <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonTfIIr0.jpg"
               alt="Gallery 2" />
          <div class="see-all-vertical">
            <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonRDryPo.jpg"
                 alt="Gallery 3" />
            <button (click)="MainImageGallery(mainImageGallery)" class="img-more"><i class="far fa-images"></i> {{Images.length}}+</button>
            <!--<div class="see-all-text">SEE ALL 40 PHOTOS</div>-->
            <ng-template #mainImageGallery>
              <div class="modal-header">
                <h4 class="modal-title pull-left">{{hotelDetails.Name}}</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="min-height: 500px;">
                <div class="hd-banner main-gallery-container" style="padding-top:0px;" id="gallery">
                  <ngx-slick-carousel #slickModal="slick-carousel" class="slider-for" [config]="slider_for">
                    <div ngxSlickItem class="item"
                         *ngFor="let im of Images;let i=index;trackBy: trackByFn;">
                      <div class="imag-gall">
                        <img *ngIf="!im" src="assets/images/main-gall-image.jpg" alt="image" draggable="false" />
                        <img *ngIf="im" src="{{im}}" alt="{{im }}" draggable="false" style="height: 350px;width: -webkit-fill-available;" />
                      </div>
                    </div>
                  </ngx-slick-carousel>
                  <ngx-slick-carousel #slickModal="slick-carousel" class="slider-nav sl-cus-nav" [config]="slider_nav">
                    <div ngxSlickItem class="item"
                         *ngFor="let im of Images;let i=index;trackBy: trackByFn;">
                      <img *ngIf="!im" src="assets/images/main-gall-small.png" alt="image" draggable="false" />
                      <img *ngIf="im" style="width: 140px;height: 79px;" src="{{im}}" alt="{{im}}" draggable="false" />
                    </div>
                  </ngx-slick-carousel>

                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

    </div>
    <div class="col-4 content-section borders-tp">
      <div class="d-flex justify-content-between">
        <div>
          <h6 class="breakfast-text">Breakfast not included</h6>
          <p class="guestxroom">{{hotelDetails.Rooms.Room[0].NoOfAdult}} x Guest | {{hotelDetails.Rooms.Room[0].NoOfRoom}} x Room</p>
          <div class="d-flex gap-1">
            <img src="./assets/img/check-circle.svg" alt="">
            <span class="free-cancellation"> Free Cancellation</span>
          </div>

        </div>
        <div class="pricing text-end">
          <h4 class="actual-price">{{CompanySetting.CurrencySymbols}}&nbsp;{{hotelDetails.MinPrice | number:'1.2-2'}}</h4>
          <p class="taxes-text"><br>Price for 1 Night</p>
        </div>
      </div>

      <div class="amenities d-flex flex-wrap gap-2 mb-3 mt-3" *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Facilities!=null && (hotelFeature.Facilities.Name!=null && hotelFeature.Facilities.Name.length>0))">
        <span class="badge bg-light text-dark border" *ngFor="let fac of hotelFeature.Facilities.Name.slice(0,4)">
          <img src="./assets/img/green-tick.svg" alt=""> {{fac}}
        </span>
        <span class="badge bg-light text-primary border" *ngIf="hotelFeature.Facilities.Name.length>4">+ More Amenities</span>
      </div>

      <div class="buttons d-flex fix-buttons">
        <button [routerLink]="[]" fragment="rooms" class="btn btn-outline-primary rounded-pill px-4 select-btn">SELECT ROOMS</button>
      </div>
    </div>
  </div>
</section>
<!-- End of desktop view -->
<!-- Mobile view -->
<section class="mob-hotel-detail">
  <div class="top-bar" id="topBar">
    <div class="mobile-view-header">
      <i class="fas fa-arrow-left back-icon" onclick="redirectToHome()"></i>
      <div class="route-details">
        <span class="route">Hotels - {{hotelDetails.Name}}</span>
        <span class="sub-details">
          {{hotelSearchRequest.CheckIn | date: "dd MMM yy"}} - {{hotelSearchRequest.CheckOut | date: "dd MMM yy"}} | {{hotelDetails.Rooms.Room[0].NoOfRoom}} Room(s) | {{hotelDetails.Rooms.Room[0].NoOfAdult}} Adult(s)
        </span>
      </div>
      <!--<div class="action-icons">
        <a href="javascript:void(0);" onclick="openModifySearch()">
          <i class="fas fa-edit action-icon"></i>
        </a>

      </div>-->
    </div>
  </div>
  <div class="headers">
    <div class="hotel-slider">
      <owl-carousel [options]="ImageMainShow"
                    [carouselClasses]="['row', 'owl-carousel']">
        <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonTfIIr0.jpg"
             alt="Hotel 1" />
        <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonatGBex.jpg"
             alt="Hotel 2" />
        <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonqN32Ra.jpg"
             alt="Hotel 3" />
      </owl-carousel>
    </div>
    <div class="badge">Hotel</div>
  </div>
  <div class="cust-card">
    <div class="mjui_sty">
      <div>
        <div class="flx_new">
          <img src="https://www.easemytrip.com/hotels/img/htlsmicn.svg" alt="hotel icon"> 5 <img src="https://www.easemytrip.com/hotels/img/star-ht.svg">
        </div>
      </div>
    </div>
    <div class="hotel-name">{{hotelDetails.Name}}</div>
    <div class="map-location">
      <i class="fas fa-map-marker-alt pe-2"></i>{{hotelDetails.DisplayAdd}}
    </div>
    <div class="rt-ratings">
      <div class="rt-ratings-box">5</div>
      <div><strong>Excellent</strong> · 6203 reviews</div>
    </div>
    <div class="property-box">
      <h6>About this property</h6>
      <p *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Description!=null)" [innerHtml]="hotelFeature.Description">
      </p>

      <div class="amenities-title">Popular Amenities</div>
      <div class="amenities-scroll pb-2">
        <span class="amenity-badge">
          <i class="fas fa-wifi pe-2"></i> Free Internet
        </span>
        <span class="amenity-badge">
          <i class="fas fa-briefcase pe-2"></i> Business services
        </span>
        <span class="amenity-badge">
          <i class="fas fa-concierge-bell pe-2"></i> 24-hour front desk
        </span>
        <span class="amenity-badge">
          <i class="fas fa-utensils pe-2"></i> Restaurant
        </span>
        <span class="amenity-badge">
          <i class="fas fa-soap pe-2"></i> Laundry
        </span>
      </div>
    </div>

  </div>
</section>
<!-- End of mobile view -->
<!-- End Of Hotel Detail Section -->
<!-- CTA Banner Section Starts -->
<section class="container cta-banner " *ngIf="showResult && hotelDetails">
  <a href="#!" target="_blank" class="">
    <img src="	https://images.emtcontent.com/hotel-img/book-with-zero-detail-desk.png" alt="">
  </a>
</section>
<!-- End Of CTA Banner Section -->
<!-- Navigation Section Start -->
<section class="nav-section">
  <div class="container">
    <div class="col-12">
      <div class=" room-nav-section">
        <div class="navigation-room">
          <ul class="menu-item navigation">
            <li><a class="nav-link active" [routerLink]="[]" fragment="rooms">Rooms</a></li>
            <li><a class="nav-link" [routerLink]="[]" fragment="overview">Overview</a></li>
            <li><a class="nav-link" [routerLink]="[]" fragment="amenities">Amenities</a></li>
            <li><a class="nav-link" [routerLink]="[]" fragment="location">Location</a></li>
            
          </ul>

        </div>
      </div>
    </div>
  </div>

</section>
<div class="nav-placeholder"></div>
<!-- End Of Navigation Section -->
<!--  Room Section Starts -->
<section class="container rooms-section-desk" id="rooms">

  <div class="col-12">
    <table *ngFor="let group of groupedRooms | keyvalue;let i=index">
      <tr *ngIf="i<1" class="border-tops table-main-heading">
        <th>Room Type</th>
        <th>Benefits</th>
        <th>Per Night Price</th>
        <th></th>
      </tr>

      <!-- Row 1 - Without Breakfast -->
      <tr *ngFor="let room of group.value;let j=index">
        <td *ngIf="j === 0" class="room-type" [attr.rowspan]="group.value.length+1">
          <strong>{{group.key}}</strong>
          <owl-carousel [options]="ImageMainShow"
                        [carouselClasses]="['row', 'owl-carousel']">
            <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonatGBex.jpg"
                 alt="Hotel 2" />
            <img src="https://media.easemytrip.com/media/Hotel/SHL-2001134915596/Common/CommonqN32Ra.jpg"
                 alt="Hotel 3" />
            <img class="room-type-img"
                 src="https://media.easemytrip.com/media/hotel/shl-2001134915596/common/commontdovh6.jpg"
                 alt="Room Image">
          </owl-carousel>

          <div class="tags">
            <span class="tag">{{room.DisplayDesc}} | {{room.DisplayMealDesc}}</span>
            <!--<span class="tag">300 Sq Ft.</span>
            <span class="tag">28 Sq.mt.</span>
            <span class="tag">City View</span>-->
          </div>
        </td>

        <td class="benefits">
          <strong class="benefits-heading">{{room.DisplayMealDesc}}</strong>
          <!--<ul>
            <li>Breakfast not included</li>
            <li>Free Wi-Fi</li>
            <li>15% Discount on Food & Beverages (IMFL only)</li>
            <li>Free Cancellation Till Check-in</li>
          </ul>-->
        </td>

        <td class="text-end">
          <div class="discount">Book Now and Get {{CompanySetting.CurrencySymbols}}&nbsp;{{room.GrossPrice | number:'1.2-2'}} Off</div>
          <div class="price">{{CompanySetting.CurrencySymbols}}&nbsp;{{room.GrossPrice | number:'1.2-2'}}</div>
          <div class="taxes-1">Including Taxes & Fees</div>
          <!--<div class="taxes-2">(Per Night)</div>-->
          <div><a (click)="getCancellationPolicy(room.HotelId,room.RoomId,room.Token,template,room.Provider)" style="cursor: pointer;">Cancellation Policy</a></div>
          <!--<span class="cancellation">
            <ul>
              <li>Free cancellation (Rs.0) before 21-May-2025 02:00 PM</li>
              <li>100% Deduction From: 21-May-2025 02:00 PM</li>
            </ul>
          </span>-->
        </td>

        <td>
          <div class="d-flex justify-content-between">
            <img style="width:50px" src="https://www.easemytrip.com/hotels/images/recommded-3.svg">
            <button class="book-now" (click)="bookHotel(room.HotelId,room.RoomId,room.Token,room.Provider)">Book Now</button>
          </div>
          <div class="text-end pt-3">
            <span class="coupon ">EMTHOTELS Coupon code is applied</span>
          </div>

        </td>
      </tr>

    </table>
  </div>
</section>

<section class="container rooms-section-mob" id="rooms">
  <div class="room-cards-mob" *ngFor="let groupm of groupedRooms | keyvalue;let i=index">
    <div class="d-flex align-items-start">
      <img src="https://img.easemytrip.com/emthotel-56787/70/23/a/s/39781895_0.jpg" alt="Room"
           class="room-image me-3">
      <div>
        <div class="room-title">{{groupm.key}}</div>
        <div class="room-details mt-1">
          <div class="room-detail-item">
            <i class="fas fa-bed"></i>
            <span>{{groupm.key}}</span>
          </div>
          <div class="room-detail-item">
            <i class="fas fa-vector-square"></i>
            <span>{{groupm.value[0].DisplayDesc}} | {{groupm.value[0].DisplayMealDesc}}</span>
          </div>
          <div class="room-detail-item">
            <i class="fas fa-city"></i>
            <span>City View</span>
          </div>
        </div>

      </div>
    </div>

    <div class="room-options">
      <!-- Option 1 -->
      <div class="option-box" *ngFor="let room of groupm.value;let j=index">
        <input type="radio" name="meal-option" class="form-check-input">
        <div class="option-content">
          <div class="option-label-row">
            <div class="option-label">{{room.DisplayMealDesc}}</div>
            <div class="price-section-inline">
              <span class="price">{{CompanySetting.CurrencySymbols}}&nbsp;{{room.GrossPrice | number:'1.2-2'}}</span>

              <span class="original-price">{{CompanySetting.CurrencySymbols}}&nbsp;{{room.GrossPrice | number:'1.2-2'}}</span>

              <div class="taxes">Including All Taxed</div>
            </div>

          </div>
          <div class="included-text"><i class="fa-solid fa-circle-check"></i>Breakfast not included</div>
          <div class="included-text"><i class="fa-solid fa-circle-check"></i>Breakfast not included</div>
          <div><a (click)="getCancellationPolicy(room.HotelId,room.RoomId,room.Token,template,room.Provider)" style="cursor: pointer;">Cancellation Policy</a></div>
        </div>
      </div>
    </div>
  </div>

</section>
<!-- End Of Room Section  -->
<!-- Hotel description Section -->
<section class="container" id="overview">
  <div class="Hotel-desc">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div>
        <h4 class="mb-1 fw-bold hotel-name">
          {{hotelDetails.Name}}
          <span class="star-rating">
            <i class="fas fa-star" *ngFor="let star of ' '.repeat(hotelDetails.Star).split('')"></i>
          </span>

        </h4>
        <p class="text-muted mb-0 hotel-location">
          <i class="fas fa-location-dot"></i> {{hotelDetails.DisplayAdd}}
        </p>
      </div>
    </div>

    <h5 *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Description!=null && hotelFeature.Description!='')">Hotel Description</h5>
    <div class="section-text" *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Description!=null && hotelFeature.Description!='')" [innerHtml]="hotelFeature.Description">
    </div>

  </div>

</section>
<!-- End Of Hotel Description Section -->
<!-- Ammenities section Starts -->
<section class="container" id="amenities">
  <div class="amenities_1">
    <h4>Amenities</h4>
    <div class="row">

      <!-- Left Column -->
      <div class="col-md-6" *ngIf="showFeature && (hotelFeature!=null && hotelFeature.RoomFacilities!=null && hotelFeature.RoomFacilities.Name != null && hotelFeature.RoomFacilities.Name.length>0)">
        <h3>Room Amenities</h3>
        <div class="row">
          <div class="col-12">
            <div class="item" *ngFor="let roomamenities of hotelFeature.RoomFacilities.Name">
              <div class="icon-heading"><i class="fas fa-wifi"></i> {{roomamenities}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-6" *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Facilities!=null && hotelFeature.Facilities.Name != null && hotelFeature.Facilities.Name.length>0)">
        <div class="vertical-divider">
          <h3>Hotel Amenities</h3>
          <div class="row">
            <div class="col-12">
              <div class="item" *ngFor="let fac of hotelFeature.Facilities.Name">
                <div class="icon-heading"><i class="fas fa-wifi"></i>{{fac}}</div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<!--  End Of Ammenities Section -->
<!-- Location section Starts -->
<section class="container " id="location">
  <div class="location-map">
    <h4>Location</h4>
    <div class="row">
      <!-- Map Column -->
      <div class="col-md-5 mb-4 mb-md-0">
        <div id="map" class="container" style="height:400px; width:100%;"></div>
      </div>

      <!-- Details Column -->
      <div class="col-md-7" *ngIf="showFeature && (hotelFeature!=null && hotelFeature.Attractions!=null && hotelFeature.Attractions.Name != null && hotelFeature.Attractions.Name.length>0)">
        <div class="row">
          <!-- What's Nearby -->
          <div class="col-12 col-md-6 mb-4">
            <h6><i class="fas fa-location-dot me-2"></i>What's nearby</h6>
            <ul class="list-unstyled location-list">
              <li><span><i class="fas fa-school"></i>Hansraj Basu Deo</span><span>950 m</span></li>

              <li>
                <span><i class="fas fa-flag"></i>Ramlila Ground Nabi Karim</span><span>1.1 km</span>
              </li>
              <li><span><i class="fas fa-bolt"></i>BSES YAMUNA POWER</span><span>1.3 km</span></li>
              <li><span><i class="fas fa-tree"></i>Durga Park</span><span>1.4 km</span></li>
              <li><span><i class="fas fa-tree-city"></i>Shivaji Park</span><span>1.5 km</span></li>
              <li>
                <span><i class="fas fa-futbol"></i>PALIKA HOSTEL PLAYGROUND</span><span>
                  1.7
                  km
                </span>
              </li>
              <li>
                <span><i class="fas fa-trophy"></i>Maha Rishi Valmiki Mini Stadium</span><span>
                  1.7
                  km
                </span>
              </li>
              <li><span><i class="fas fa-leaf"></i>Motia Khan Park</span><span>1.8 km</span></li>
              <li><span><i class="fas fa-building"></i>PRESS ENCLAVE</span><span>1.8 km</span></li>
            </ul>
          </div>

          <!-- Top Attractions -->
          <div class="col-12 col-md-6" *ngIf="hotelFeature!=null && hotelFeature.Attractions!=null">
            <h6><i class="fas fa-star me-2"></i>Top attractions</h6>
            <ul class="list-unstyled location-list">
              <li *ngFor="let fac of hotelFeature.Attractions.Name">
                <span><i class="fas fa-landmark"></i>{{fac}}</span>
                <span>3.6 km</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>

<!--  End Of Location Section -->
<!-- bottom sticky continue -->
<div class="mobile-bottom-banner d-block d-sm-none">

  <div class="price-box">
    <div>
      <p class="price-text mb-1">₹2,12,999</p>
      <div class="sub-text">per person on twin sharing</div>
    </div>
    <button class="enquire-btn">Continue</button>
  </div>
</div>
<!-- End Of bottom sticky continue -->
<!-- Popup Gallery Section-->
<div class="gallery-overlay" id="galleryOverlay" style="display: none;">
  <div class="gallery-background"></div>
  <div class="gallery-wrapper">
    <!-- Your existing gallery HTML starts here -->
    <div class="hotel-header">
      The Suryaa New Delhi
      <button class="close-btn" id="closeGallery" aria-label="Close">&times;</button>
    </div>

    <!-- Tab Navigation -->
    <div class="tab-bar" id="tabButtons">
      <button class="tab-button" data-tab="rooms">Rooms</button>
      <button class="tab-button active" data-tab="bedroom">Bedroom</button>
      <button class="tab-button" data-tab="washroom">Washroom</button>
      <button class="tab-button" data-tab="livingroom">Living Room</button>
      <button class="tab-button" data-tab="gym">GYM</button>
      <button class="tab-button" data-tab="external">External</button>
      <button class="tab-button" data-tab="lobby">Lobby</button>
      <button class="tab-button" data-tab="spa">SPA</button>
      <button class="tab-button" data-tab="conference">Conference Hall</button>
      <button class="tab-button" data-tab="exterior">Exterior</button>
    </div>

    <!-- Tab Contents -->
    <div class="container-fluid image-grid">

      <!-- Bedroom Tab -->
      <div class="row g-3 tab-content-section active" data-tab-content="rooms">
        <div class="col-6 col-md-3">
          <img src="https://img.easemytrip.com/roomimages/emthotel-56787/32/444749/324788872_1.jpg"
               alt="rooms">
        </div>
        <div class="col-6 col-md-3">
          <img src="https://img.easemytrip.com/emthotel-56787/70/23/a/s/39781895_0.jpg" alt="rooms">
        </div>
        <!-- Add more bedroom images as needed -->
      </div>

      <!-- Bedroom Tab -->

      <div class="row g-3 tab-content-section" data-tab-content="bedroom">
        <div class="col-6 col-md-3">
          <img src="https://img.easemytrip.com/roomimages/emthotel-56787/32/444749/324788872_1.jpg"
               alt="Bedroom">
        </div>
        <div class="col-6 col-md-3">
          <img src="https://img.easemytrip.com/emthotel-56787/70/23/a/s/39781895_0.jpg" alt="Bedroom">
        </div>
        <!-- Add more bedroom images as needed -->
      </div>

      <!-- Washroom Tab -->
      <div class="row g-3 tab-content-section" data-tab-content="washroom">
        <div class="col-6 col-md-3">
          <img src="https://img.easemytrip.com/emthotel-56787/70/23/a/s/39781895_0.jpg" alt="washroom">
        </div>
      </div>
    </div>

    <!-- Living Room Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="livingroom">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="Living Room">
      </div>
    </div>

    <!-- Gym Room Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="gym">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="GYM">
      </div>
    </div>

    <!-- External Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="external">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="External">
      </div>
    </div>

    <!-- Lobby Room Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="lobby">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="Lobby">
      </div>
    </div>

    <!-- SPA Room Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="spa">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="SPA">
      </div>
    </div>

    <!-- Conference Room Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="conference">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="Conference">
      </div>
    </div>

    <!-- Exterior Tab -->
    <div class="row g-3 tab-content-section" data-tab-content="exterior">
      <div class="col-6 col-md-3">
        <img src="https://via.placeholder.com/300x180?text=Living+Room+1" alt="Exterior">
      </div>
    </div>
  </div>
</div>
<!-- End Of Popup Gallery  -->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Cancellation Policy</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngFor="let Policy of CancellationPolicy.Policies.Policy;">
      If you cancel booking between {{Policy.DateFrom}} To
      {{Policy.DateTo}} then Cancellation Charges will be
      {{Policy.Currency}} {{Policy.GrossPrice}}
    </p>
    <p>Note:- In case of multiple cancellation policies with same date range, after cancellation; highest cancellation charges will be applicable.</p>
  </div>
</ng-template>
<app-loader *ngIf="loader"></app-loader>
